<template>
    <div class="flex flex-col-reverse sm:flex-row bg-white rounded-2xl w-full">
        <div class="w-full p-8 lg:w-1/2 space-y-12">
            <template v-if="isLoading">
                <div class="flex items-center justify-center w-full h-full">
                    <div class="flex justify-center items-center space-x-1 text-sm text-gray-700">

                        <svg fill='none' class="w-6 h-6 animate-spin" viewBox="0 0 32 32"
                            xmlns='http://www.w3.org/2000/svg'>
                            <path clip-rule='evenodd'
                                d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                fill='currentColor' fill-rule='evenodd' />
                        </svg>


                        <div>En cours d'envoi ...</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <template v-if="!successMessage">
                    <TitleH2 titleText="Contactez-nous pour réaliser votre personnalisation"></TitleH2>
                    <form class="max-w-md mx-auto text-left" @submit.prevent="submitForm">
                        <div class="mb-5">
                            <label for="identity" class="mb-3 block text-base font-medium text-[#07074D]">
                                Nom du club
                            </label>
                            <input v-model="form.name" required type="text" name="identity" id="identity"
                                placeholder="Surfing Club"
                                class="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-linen focus:shadow-md" />
                        </div>

                        <div class="-mx-3 flex flex-wrap">
                            <div class="w-full px-3 sm:w-1/2">
                                <div class="mb-5">
                                    <label for="email" class="mb-3 block text-base font-medium text-[#07074D]">
                                        E-mail
                                    </label>
                                    <input v-model="form.email" required type="email" name="email" id="email"
                                        placeholder="pierre@gmail.com"
                                        class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-linen focus:shadow-md" />
                                </div>
                            </div>
                            <div class="w-full px-3 sm:w-1/2">
                                <div class="mb-5">
                                    <label for="phone" class="mb-3 block text-base font-medium text-[#07074D]">
                                        Téléphone
                                    </label>
                                    <input v-model="form.phone" required type="phone" name="phone" id="phone"
                                        placeholder="01 23 45 67 89"
                                        class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-linen focus:shadow-md" />
                                </div>
                            </div>
                        </div>

                        <div class="mb-5">
                            <label class="mb-3 block text-base font-medium text-[#07074D]">
                                Zone de personnalisation (sélection multiple possible)
                            </label>
                            <div class="flex gap-4">
                                <label class="flex items-center cursor-pointer">
                                    <input v-model="form.customizationZones" type="checkbox" value="Coeur"
                                        class="w-4 h-4 text-indigo-600 focus:ring-indigo-500 rounded" />
                                    <span class="ml-2 text-base text-[#6B7280]">Coeur</span>
                                </label>
                                <label class="flex items-center cursor-pointer">
                                    <input v-model="form.customizationZones" type="checkbox" value="Dos"
                                        class="w-4 h-4 text-indigo-600 focus:ring-indigo-500 rounded" />
                                    <span class="ml-2 text-base text-[#6B7280]">Dos</span>
                                </label>
                            </div>
                        </div>

                        <div class="mb-5">
                            <label class="mb-3 block text-sm font-medium text-[#07074D]">
                                Sélection des tailles (minimum 10 pièces)
                            </label>
                            <div class="grid grid-cols-1 sm:grid-cols-1 gap-2">
                                <div v-for="size in ['S/M', 'L/XL', '2XL/3XL']" :key="size"
                                    class="group relative overflow-hidden rounded-lg transition-all duration-300 bg-white border border-gray-200 hover:border-indigo-300 hover:shadow-sm">
                                    <div class="relative p-2.5">
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center">
                                                <div class="w-16 h-9 rounded-lg flex items-center justify-center font-bold text-sm transition-colors bg-indigo-100 text-indigo-600">
                                                    {{ size }}
                                                </div>
                                            </div>
                                            <div class="flex items-center gap-2">
                                                <button type="button" @click="decrementSize(size)"
                                                    :disabled="form.sizes[size] === 0"
                                                    class="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-offset-1"
                                                    :class="form.sizes[size] === 0 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-indigo-100 text-indigo-600 hover:bg-indigo-200 focus:ring-indigo-300'">
                                                    <i class="fas fa-minus text-xs"></i>
                                                </button>
                                                <div class="min-w-[2.5rem] text-center text-gray-900">
                                                    <div class="text-lg font-bold">{{ form.sizes[size] }}</div>
                                                    <div class="text-[10px] opacity-75 leading-none">pcs</div>
                                                </div>
                                                <button type="button" @click="incrementSize(size)"
                                                    class="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-offset-1 bg-indigo-100 text-indigo-600 hover:bg-indigo-200 focus:ring-indigo-300">
                                                    <i class="fas fa-plus text-xs"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-sm text-gray-600 mt-3">
                                Total : <span class="font-bold" :class="totalQuantity < 10 ? 'text-red-600' : 'text-green-600'">{{ totalQuantity }}</span> pièces
                            </div>
                        </div>

                        <!-- Alert pour encourager à commander plus -->
                        <div v-if="nextTierAlert" class="mb-5 p-3 bg-gradient-to-r from-amber-50 to-yellow-50 border border-amber-200 rounded-lg shadow-sm">
                            <div class="flex items-center gap-2.5">
                                <div class="flex-shrink-0">
                                    <div class="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center">
                                        <svg class="w-4 h-4 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="flex-1">
                                    <div class="text-[10px] font-semibold text-amber-600 uppercase tracking-wide mb-0.5">Économisez plus</div>
                                    <div class="text-xs font-medium text-gray-700">{{ nextTierAlert }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-5">
                            <label for="message" class="mb-3 block text-base font-medium text-[#07074D]">
                                Message
                            </label>
                            <textarea v-model="form.message" name="floating_message" id="floating_message"
                                class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-linen focus:shadow-md h-40"
                                placeholder=" " required>
                            </textarea>
                        </div>

                        <Button textButton="Envoyez" dark></Button>
                    </form>
                </template>
                <template v-else>
                    <p>{{ successMessage }}</p>
                </template>
            </template>
        </div>
        <div class="block sm:w-1/2 bg-cover bg-center rounded-t-2xl sm:rounded-tr-2xl sm:rounded-br-2xl h-32 sm:h-auto"
            :style="backgroundImage">
        </div>
    </div>
</template>


<script>
import imageUrl from '@/assets/images/contact.jpg';
import TitleH2 from '@/Components/Typography/Headings/TitleH2.vue';
import Button from '@/Components/Buttons/Button.vue';

import axios from 'axios';

export default {
    components: {
        TitleH2,
        Button
    },
    props: {
        initialSizes: {
            type: Object,
            default: () => ({
                'S/M': 0,
                'L/XL': 0,
                '2XL/3XL': 0
            })
        }
    },
    data() {
        return {
            backgroundImage: `background-image: url(${imageUrl})`,
            form: {
                name: '',
                email: '',
                phone: '',
                message: '',
                customizationZones: [],
                sizes: { ...this.initialSizes }
            },
            successMessage: '',
            isLoading: false
        };
    },
    computed: {
        totalQuantity() {
            return Object.values(this.form.sizes).reduce((sum, qty) => sum + qty, 0);
        },

        unitPrice() {
            const qty = this.totalQuantity;
            if (qty < 10) return 59;
            if (qty >= 10 && qty <= 20) return 59;
            if (qty >= 21 && qty <= 49) return 55;
            if (qty >= 50 && qty <= 99) return 53;
            return 49; // 100+
        },

        nextTierAlert() {
            const qty = this.totalQuantity;
            const basePrice = 59;

            if (qty < 10) {
                return null;
            }

            if (qty >= 10 && qty <= 20) {
                const piecesNeeded = 21 - qty;
                const currentSavings = (basePrice - 59) * qty; // 0€
                return `Vous bénéficiez de ${currentSavings}€ de réduction. Le prochain palier nécessite ${piecesNeeded} pièce${piecesNeeded > 1 ? 's' : ''} pour avoir la pièce à 55€ HT/u au lieu de 59€ HT/u`;
            }

            if (qty >= 21 && qty <= 49) {
                const piecesNeeded = 50 - qty;
                const currentSavings = (basePrice - 55) * qty;
                return `Vous bénéficiez de ${currentSavings}€ de réduction. Le prochain palier nécessite ${piecesNeeded} pièce${piecesNeeded > 1 ? 's' : ''} pour avoir la pièce à 53€ HT/u au lieu de 59€ HT/u`;
            }

            if (qty >= 50 && qty <= 99) {
                const piecesNeeded = 100 - qty;
                const currentSavings = (basePrice - 53) * qty;
                return `Vous bénéficiez de ${currentSavings}€ de réduction. Le prochain palier nécessite ${piecesNeeded} pièce${piecesNeeded > 1 ? 's' : ''} pour avoir la pièce à 49€ HT/u au lieu de 59€ HT/u`;
            }

            if (qty >= 100) {
                const currentSavings = (basePrice - 49) * qty;
                return `Bravo ! Vous bénéficiez de ${currentSavings}€ de réduction avec le meilleur tarif !`;
            }

            return null;
        }
    },
    watch: {
        initialSizes: {
            handler(newSizes) {
                if (newSizes && Object.values(newSizes).some(qty => qty > 0)) {
                    this.form.sizes = { ...newSizes };
                }
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
        incrementSize(size) {
            this.form.sizes[size]++;
        },
        decrementSize(size) {
            if (this.form.sizes[size] > 0) {
                this.form.sizes[size]--;
            }
        },
        async submitForm() {
            if (this.totalQuantity < 10) {
                alert('La quantité minimale est de 10 pièces. Veuillez ajuster vos sélections.');
                return;
            }

            this.isLoading = true;
            try {
                const response = await axios.post(`${process.env.VUE_APP_API_URL}api/send`, this.form);
                if (response.status === 200) {
                    this.successMessage = 'Votre message a été envoyé avec succès.';
                    this.form = {
                        name: '',
                        email: '',
                        phone: '',
                        message: '',
                        customizationZones: [],
                        sizes: { 'S/M': 0, 'L/XL': 0, '2XL/3XL': 0 }
                    };
                    this.$router.push({ name: 'success' });
                }
            } catch (error) {
                console.error('Erreur lors de l\'envoi du formulaire:', error);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
